import axios from "axios";
import { GetAllLaboratoryDTO, GetAllLaboratoryFiltersDTO, GetAllSampleCollectionDTO, GetAllSampleCollectionFiltersDTO, SampleCollectionCreationDTO, SampleCollectionDTO, SampleCollectionUpdateDTO } from "./dto";
import { LaboratoryService, SampleCollectionService } from "./service";
import { keycloak } from "../../../../../../lib/keycloak";

export class SampleCollectionServiceImpl implements SampleCollectionService {

    public CreateSampleCollection(data: SampleCollectionCreationDTO): Promise<void> {
        return axios.post("/api/sample-collection",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateSampleCollection(data: SampleCollectionUpdateDTO, id: string): Promise<void> {
        return axios.put("/api/sample-collection/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteSampleCollection(id: string): Promise<void> {
        return axios.delete("/api/sample-collection/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllSampleCollection(filters: GetAllSampleCollectionFiltersDTO): Promise<GetAllSampleCollectionDTO> {
        return axios.get("/api/sample-collection", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                inspectionVisitId: filters.inspectionVisitId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetSampleCollectionById(id: string): Promise<SampleCollectionDTO> {
        return axios.get("/api/sample-collection/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}

export class LaboratoryServiceImpl implements LaboratoryService {

    // TO IMPLEMENT

    public GetAllLaboratory(filters: GetAllLaboratoryFiltersDTO): Promise<GetAllLaboratoryDTO> {
        return axios.get("/api/laboratory", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}